import { createSlice } from "@reduxjs/toolkit";
import {
  getChapters,
  getNovelsChaps,
  createNovelsChaps,
  updateNovelsChaps,
  deleteNovelsChaps,
  deleteNovelsChapsAll,
} from "../3- actions/novels";
export const counterSlice = createSlice({
  name: "novelsChaps",
  initialState: {
    novelChaps: [],
    novelChapters: [],
  },
  reducers: {
    CLEAR_CHAPTERS(state) {
      state.novelChaps = [];
      state.novelChaps.pending = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getNovelsChaps.fulfilled, (state, action) => {
      state.novelChaps = {
        ...state.novelChaps,
        chapters: action.payload,
        pending: false,
      };
    });
    builder.addCase(getNovelsChaps.pending, (state, action) => {
      state.novelChaps = {
        ...state.novelChaps,
        pending: true,
      };
    });

    builder.addCase(getChapters.fulfilled, (state, action) => {
      state.novelChapters = action.payload;
    });
    builder.addCase(createNovelsChaps.fulfilled, (state, action) => {
      state.novelChapters = [...state.novelChapters, action.payload];
    });
    builder.addCase(updateNovelsChaps.fulfilled, (state, action) => {
      state.novelChapters = state.novelChapters.map((novel) =>
        novel._id === action.payload._id ? action.payload : novel
      );
    });
    builder.addCase(deleteNovelsChaps.fulfilled, (state, action) => {
      state.novelChapters = state.novelChapters.filter(
        (novel) => novel._id !== action.payload
      );
    });
    builder.addCase(deleteNovelsChapsAll.fulfilled, (state, action) => {
      state.novelChapters = state.novelChapters.filter(
        (novel) => novel.Novel_id !== action.payload
      );
    });
  },
});

export default counterSlice.reducer;
export const { CLEAR_CHAPTERS } = counterSlice.actions;
